// extracted by mini-css-extract-plugin
module.exports = {"content":"_927a99ad28--content--Wt9wt","header":"_927a99ad28--header--bF0NE"};